<ion-item class="input-item ion-no-padding faq-search">
    <ion-input [(ngModel)]="searchText"
               (ngModelChange)="search($event)"
               [debounce]="faqDebounce"
               [clearInput]="true"
               class="closeKeyboard"
               autocapitalize="none"
               enterkeyhint="done"
               name="searchText"
               type="text"
               [placeholder]="'faq.placeholder' | translate">
    </ion-input>
</ion-item>
